import React from 'react';
import Image from 'gatsby-image'
import InstaImage from '../components/InstaImage'
import CTA from '../components/CTA'
import logo from '../../static/images/logo.svg'

import '../../sass/components/_sidebar.scss';

class Sidebar extends React.Component {

  constructor(props) {
    super(props);
  }

  render(){
    return (
      <aside className="sidebar">
        {/*<img className="logo" src={logo} />*/}
        <img alt="logo" className="logo" src={logo} />
        <div className="instaWrap">
          <div className="instaUserInfo">
            <p className="instaPosts">{this.props.instagramUser.userPostCount} posts</p>
            <p className="instaFollowers">{this.props.instagramUser.userFollowers} followers</p>
            <p className="instaBio">{this.props.instagramUser.userBio}</p>
            <CTA external to={`https://www.instagram.com/${this.props.instagramUser.userName}`} className="instafollow" label={`@${this.props.instagramUser.userName}`} />
          </div>
          <div className="instaImages">
            <InstaImage key="0" postData={this.props.instagramUser} />
            {this.props.instagramPosts.map(function({ node }, index) {
              if (index>0) return <InstaImage key={index} postData={node}/>;
            })}
          </div>
        </div>
      </aside>
    )
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar.js